import {find, head, last} from 'lodash';
import {Route, Redirect, RouteProps} from 'react-router-dom';

import {ROUTE_PATH} from 'constants/routes';
import {authDataStore} from 'services';
import {userAuthUtils} from 'utils';

import {nativeInterfaceUtils} from './native-interface';

const redirectToLogin = () => {
    userAuthUtils.resetLocalData();
    const previousPath = location?.pathname;
    return <Redirect to={{pathname: ROUTE_PATH.PUBLIC.LOGIN, state: {previousPath}}} />;
};

export const AuthRoute = (props) => {
    if (userAuthUtils.isLoggedIn()) {
        if (!userAuthUtils.getUserPermissions()) {
            return null;
        }
        return <Route {...props} />;
    } else {
        return redirectToLogin();
    }
};

type PrivateRouteProps = RouteProps<any, any> & {
    path: string;
    permission?: string[];
};
export const PrivateRoute = (props: PrivateRouteProps) => {
    if (!userAuthUtils.isLoggedIn()) {
        return redirectToLogin();
    }

    if (!userAuthUtils.getUserPermissions()) {
        return null;
    }

    const isEnabled = last(props.permission) === 'self' ?
        userAuthUtils.isParentRouteEnabled(head(props.permission)) :
        userAuthUtils.isRouteEnabled(props.permission);

    if (isEnabled) {
        return <Route {...props} />;
    } else {
        return <Redirect to={userAuthUtils.getUserDefaultPage()} />;
    }
};

export const RedirectToPrivateRoute = (props: {routes: PrivateRouteProps[]}) => {
    const {routes} = props;
    if (!userAuthUtils.isLoggedIn()) {
        return redirectToLogin();
    }
    const enabledRoute = find(routes, (route) => userAuthUtils.isRouteEnabled(route.permission));
    if (enabledRoute) {
        return <Redirect to={enabledRoute.path} />;
    }
    return <Redirect to={userAuthUtils.getUserDefaultPage()} />;
};

export const NotAuthRoute = (props: any) => {
    const isRedirectToLoginOnLogout = props.path === ROUTE_PATH.PUBLIC.LOGIN && authDataStore.getValue().logoutInProgress;
    if (!userAuthUtils.isLoggedIn() || isRedirectToLoginOnLogout) {
        return <Route {...props} />;
    }
    return <Redirect to={userAuthUtils.getUserDefaultPage()} />;
};

export const NativeRoute = (props) =>
    nativeInterfaceUtils.isWebView()
        ? <Route {...props} />
        : null;